import { DataModel } from "../../../../lib/data/model/DataModel.js";

export class RolePrivilegeModel extends DataModel {

    static _instance = null;

    static getInstance(authManager) {

        if (RolePrivilegeModel._instance == null) RolePrivilegeModel._instance = new RolePrivilegeModel(authManager);
        return RolePrivilegeModel._instance;

    }

    constructor (authManager) {

        super(authManager, 'core/role-privileges');

        this.entityName = 'core.RolePrivilege';
        this.privileges = {
            create: [["adminUsers"]],
            read: [["adminUsers"],["manageUsers"],["editUsers"],["readUsers"]],
            update: [["adminUsers"]],
            delete: [["adminUsers"]],
        };

        this.label = 'Role Privilege';
        this.setLabel = 'Role Privileges';

        this.browser = {
            name: 'default-core-roleprivilege-browser',
            moduleName: 'default-core-roleprivilege-browser',
            moduleTitle: 'Role Privileges',
            moduleStateSlotName: 'default-core-roleprivilege-browser',
        };

        this.editor = {
            name: 'default-core-roleprivilege-editor',
            moduleName: 'default-core-roleprivilege-editor',
            moduleTitle: 'Role Privilege',
            moduleStateSlotName: 'default-core-roleprivilege-editor',
        };

        this.fieldDefs = [
            {
                name: 'id',
                type: 'int',
                persistent: true,
                label: '#ID',
                primaryKey: true,
                required: true,
                readOnly: true,
            },
            {
                name: 'uid',
                type: 'string',
                persistent: true,
                label: 'Unique ID',
                required: true,
                readOnly: true,
            },
            {
                name: 'roleId',
                type: 'Role',
                persistent: true,
                label: 'Role',
            },
            {
                name: 'roleLabel',
                type: 'string',
                persistent: false,
                label: 'Role',
                distinctLabel: 'Role (Text)',
                readOnly: true,
            },
            {
                name: 'privilegeId',
                type: 'Privilege',
                persistent: true,
                label: 'Privilege',
            },
            {
                name: 'privilegeLabel',
                type: 'string',
                persistent: false,
                label: 'Privilege',
                readOnly: true,
            },
        ];

    }

}
